import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToasterService } from 'angular2-toaster';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/observable/of';
import swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { CouponCodeClientService } from '../../../services/index';

@Component({
    selector: 'add-edit-coupon-code-client-window',
    templateUrl: './addEditCouponCodeClient.component.html'
})
export class AddEditCouponCodeClientComponent implements OnInit {
    public title: string;
    public mode: string;

    private _recordData: any = {};
    get recordData(): any { return this._recordData; }
    set recordData(val: any) {
        this._recordData = val;
        if (val && val.mobile) {
            this.mobileSearchText = val.mobile;
        }
    }

    @ViewChild('fileUpload') fileUpload;

    isLoading: boolean = false;
    isExcelMode: boolean = false;
    previewList: any[] = [];
    couponCodeList: any[] = [];

    // Mobile search
    private mobileSearchTerms = new Subject<string>();
    mobileSearchText: string = '';
    clientList: any[] = [];
    showClientDropdown: boolean = false;

    @Output() recordLoadEvent = new EventEmitter();

    constructor(
        private couponCodeClientService: CouponCodeClientService,
        public snackBar: MdSnackBar,
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        this.loadCouponCodes();

        // Debounced mobile search
        this.mobileSearchTerms
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term => term && term.length >= 1
                ? this.couponCodeClientService.getClientByMobile(term)
                : Observable.of({ success: true, data: [] }))
            .subscribe((res: any) => {
                if (res && res.success && res.data && res.data.length > 0) {
                    this.clientList = res.data;
                    this.showClientDropdown = true;
                } else {
                    this.clientList = [];
                    this.showClientDropdown = false;
                }
            });

        setTimeout(() => {
            $('#mobileSearch').focus();
        }, 100);
    }

    loadCouponCodes() {
        this.couponCodeClientService.getActiveCouponCodes().then((res: any) => {
            if (res && res.data) {
                this.couponCodeList = res.data;
            }
        });
    }

    searchMobile(query: string) {
        this.mobileSearchText = query;
        if (!query) {
            this.clearMobile();
            return;
        }
        this.mobileSearchTerms.next(query);
    }

    onSelectMobile(client: any) {
        this.recordData.mobile = client.mobile;
        this.mobileSearchText  = client.mobile;
        this.clientList        = [];
        this.showClientDropdown = false;
    }

    clearMobile() {
        this.recordData.mobile  = '';
        this.mobileSearchText   = '';
        this.clientList         = [];
        this.showClientDropdown = false;
    }

    onToggleMode() {
        this.previewList = [];
        this.clearMobile();
        this.recordData.coupon_code = '';
    }

    onSave(): void {
        if (this.mode === 'Add' && this.isExcelMode) {
            if (this.previewList.length === 0) { return; }
            this.isLoading = true;
            const params = { data: JSON.stringify({ Sheet1: this.previewList }) };
            this.couponCodeClientService.saveExcelData(params).then((res: any) => {
                this.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    this.bsModalRef.hide();
                    this.recordLoadEvent.emit();
                } else {
                    const lines = res.subMessage ? res.subMessage.split('\n').filter(l => l.trim()) : [];
                    const listHtml = lines.map(l => `<li style="margin-bottom:4px;">${l}</li>`).join('');
                    swal({
                        title: res.message,
                        html: `<div style="max-height:260px;overflow-y:auto;text-align:left;font-size:13px;">
                                   <ul style="padding-left:18px;margin:0;">${listHtml}</ul>
                               </div>`,
                        type: 'error'
                    });
                }
            });
        } else {
            if (!this.recordData.mobile) {
                this.toasterService.pop('error', 'ERROR', 'Please enter a Mobile number');
                return;
            }
            const that = this;
            this.isLoading = true;
            const params = Object.assign({}, this.recordData, { mode: this.mode });
            this.couponCodeClientService.addUpdateRecord(params).then((res: any) => {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.recordLoadEvent.emit();
                } else {
                    that.toasterService.pop('error', 'ERROR', res.message);
                }
            });
        }
    }

    isViewMode(): boolean {
        return this.mode === 'View';
    }

    // ── Excel upload ──────────────────────────────────────────────────────────

    downloadFile() {
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet([['MOBILE', 'COUPON CODE']]);
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        const now = new Date();
        const pad = (n: number) => n.toString().padStart(2, '0');
        const timestamp = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;
        XLSX.writeFile(wb, `CouponCodeReceivedSample_${timestamp}.xlsx`);
    }

    uploadFile(event: any) {
        if (!event.target.files || event.target.files.length === 0) { return; }
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e: any) => {
            const workBook = XLSX.read(e.target.result, { type: 'binary' });
            const sheetNames = workBook.SheetNames;

            if (sheetNames.length !== 1) {
                swal({ title: 'Please upload a file with only ONE sheet.' });
                this.fileUpload.nativeElement.value = '';
                return;
            }

            const jsonData: any = {};
            sheetNames.forEach(name => {
                jsonData[name] = XLSX.utils.sheet_to_json(workBook.Sheets[name]);
            });

            const rows = jsonData['Sheet1'] || [];
            if (rows.length === 0) {
                swal({ title: 'The uploaded file is empty.' });
                this.fileUpload.nativeElement.value = '';
                return;
            }

            const firstRow = rows[0];
            if (!firstRow.hasOwnProperty('MOBILE') || !firstRow.hasOwnProperty('COUPON CODE')) {
                swal({ title: 'Invalid file format. Required columns: MOBILE, COUPON CODE' });
                this.fileUpload.nativeElement.value = '';
                return;
            }

            this.previewList = rows;
            this.fileUpload.nativeElement.value = '';
        };

        reader.readAsBinaryString(file);
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/couponCodeClient/addEditCouponCodeClient.component.ts